var map = {
	"./alliumtrades.css": [
		5484,
		5484
	],
	"./excotrades.css": [
		84361,
		4361
	],
	"./minosmarkets.css": [
		39370,
		9370
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12466;
module.exports = webpackAsyncContext;